@if (label) {
    <div class="header">
        <div class="header-label">
            <div class="header-label-title">
                {{ label | translate: i18nParams }}
            </div>
        </div>
    </div>
}
<div class="main">
    <ng-content></ng-content>
</div>

